import Vue from "vue";
import "./plugins/bootstrap-vue";
import NProgress from "vue-nprogress";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTilt from "vue-tilt.js";
import "./registerServiceWorker";
import Notifications from "vue-notification";

Vue.use(VueTilt);
Vue.use(Notifications);

// NProgress options
const optionsNProgress = {
  latencyThreshold: 800, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: false // Show progressbar when doing Vue.http, default: true
};

Vue.use(NProgress, optionsNProgress);

const nprogress = new NProgress({ parent: "body" });
nprogress.configure({ minimum: 0.01 });
nprogress.configure({ trickleRate: 0.02, trickleSpeed: 800 });
nprogress.inc(0.2);
nprogress.set(0.5);
// console.log("-------------");
// console.log(nprogress.isStarted);
// console.log(nprogress.settings);

Vue.config.productionTip = false;

new Vue({
  router,
  nprogress,
  store,
  render: h => h(App)
}).$mount("#app");
